import { createContext } from "react"

export interface ShowFrontEndInterface {
  NosServicesRef: any,
  LegalRegTextRef: any,
  HomePageRef: any,
  InstructionRef: any,
  ComplaintRef: any,
  NewsRef: any,
  showImage: boolean, setShowImage: (showImage: boolean) => void,
}

export const DefaultShowFrontEndInterface: ShowFrontEndInterface = {
  NosServicesRef: null,
  LegalRegTextRef: null,
  HomePageRef: null,
  InstructionRef: null,
  ComplaintRef: null,
  NewsRef: null,
  showImage: false, setShowImage: () => {},
}

export const ShowFrontEndContext = createContext<ShowFrontEndInterface | any>(DefaultShowFrontEndInterface)
